module.exports = __webpack_public_path__ + "static/media/ic-contact-map-pin.39786abf.svg";